import React from 'react';
import { FiGlobe, FiInstagram, FiMail, FiMessageCircle } from 'react-icons/fi';
import { MessengerIcon } from '../icons/MessengerIcon';
import { CHANNEL_FILTER_OPTIONS, ConversationChannelFilter, ReplyChannel } from './conversationTimeline';
import './emailConversation.css';

export type { ReplyChannel };

/** Escolhe por onde responder nesta conversa. */
export const ReplyChannelSwitch: React.FC<{
  value: ReplyChannel;
  onChange: (value: ReplyChannel) => void;
  whatsappAvailable: boolean;
  emailAvailable: boolean;
  /** Só com a identidade do Instagram do cliente e a conta ativa no setor. */
  instagramAvailable?: boolean;
  /** Só com a identidade do Messenger (PSID da Página) do cliente e a Página ativa no setor. */
  messengerAvailable?: boolean;
  /** Só com a identidade de site (webchat) do cliente. */
  webchatAvailable?: boolean;
}> = ({ value, onChange, whatsappAvailable, emailAvailable, instagramAvailable = false, messengerAvailable = false, webchatAvailable = false }) => (
  <div className="reply-channel-switch" role="tablist" aria-label="Responder por">
    <span className="reply-channel-label">Responder por</span>
    <button
      type="button"
      role="tab"
      aria-selected={value === 'whatsapp'}
      className={`reply-channel-option ${value === 'whatsapp' ? 'active' : ''}`}
      onClick={() => onChange('whatsapp')}
      disabled={!whatsappAvailable}
      title={whatsappAvailable ? 'Responder pelo WhatsApp' : 'Este cliente não tem WhatsApp'}
    >
      <FiMessageCircle size={13} aria-hidden="true" /> WhatsApp
    </button>
    <button
      type="button"
      role="tab"
      aria-selected={value === 'email'}
      className={`reply-channel-option ${value === 'email' ? 'active' : ''}`}
      onClick={() => onChange('email')}
      disabled={!emailAvailable}
      title={emailAvailable ? 'Responder por e-mail' : 'E-mail indisponível para esta conversa'}
    >
      <FiMail size={13} aria-hidden="true" /> E-mail
    </button>
    {instagramAvailable && (
      <button
        type="button"
        role="tab"
        aria-selected={value === 'instagram'}
        className={`reply-channel-option ${value === 'instagram' ? 'active' : ''}`}
        onClick={() => onChange('instagram')}
        title="Responder pelo Instagram"
      >
        <FiInstagram size={13} aria-hidden="true" /> Instagram
      </button>
    )}
    {messengerAvailable && (
      <button
        type="button"
        role="tab"
        aria-selected={value === 'messenger'}
        className={`reply-channel-option ${value === 'messenger' ? 'active' : ''}`}
        onClick={() => onChange('messenger')}
        title="Responder pelo Messenger"
      >
        <MessengerIcon size={13} aria-hidden="true" /> Messenger
      </button>
    )}
    {webchatAvailable && (
      <button
        type="button"
        role="tab"
        aria-selected={value === 'webchat'}
        className={`reply-channel-option ${value === 'webchat' ? 'active' : ''}`}
        onClick={() => onChange('webchat')}
        title="Responder pelo chat do site"
      >
        <FiGlobe size={13} aria-hidden="true" /> Site
      </button>
    )}
  </div>
);

/** Filtro por canal da lista de Conversas. */
export const ChannelFilterSelect: React.FC<{
  value: ConversationChannelFilter;
  onChange: (value: ConversationChannelFilter) => void;
  /** Padrão: WhatsApp e e-mail. O Instagram entra por <c>channelFilterOptions</c> quando o setor tem conta ativa. */
  options?: { value: ConversationChannelFilter; label: string }[];
}> = ({ value, onChange, options = CHANNEL_FILTER_OPTIONS }) => (
  <label className="channel-filter">
    <span className="channel-filter-label">Canal</span>
    <select
      aria-label="Filtrar conversas por canal"
      value={value}
      onChange={(e) => onChange(e.target.value as ConversationChannelFilter)}
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  </label>
);
